import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ForestryStatusService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ForestryStatusCreateDto,
  ForestryStatusDto,
  ForestryStatusExcelDownloadDto,
  ForestryStatusUpdateDto,
} from '../proxy/planning/dtos/forestry-status';
import { FORESTRYSTATUS_CONFIG, FORESTRYSTATUS_FIELDS } from './forestry-status.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-forestry-status',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ForestryStatusService, ConfirmationService],
  templateUrl: './forestry-status.html',
  styleUrl: './forestry-status.scss',
})
export class ForestryStatus extends BaseCrudComponent<
  ForestryStatusDto,
  ForestryStatusCreateDto,
  ForestryStatusUpdateDto,
  ForestryStatusExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(ForestryStatusService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('ForestryStatus', ids),
  };
  config = FORESTRYSTATUS_CONFIG;
  fields = FORESTRYSTATUS_FIELDS;

  protected prepareUpdateDto(data: any, selected: ForestryStatusDto): ForestryStatusUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ForestryStatus';
  }
}
